module.exports = __webpack_public_path__ + "img/yiduxinxiang.ca3f8de2.png";